import { LocaleContext } from '@/providers/locale-provider'
import { LocaleConstants } from '@lib-helpers'
import { DictionaryContext, DictionaryText, FormField, SelectInput, SelectOption } from '@lib-components'
import { use, useState, ReactElement } from 'react'

const LanguageSwitch = (): ReactElement => {
    const { setLocale } = use(LocaleContext)
    const [selectedLocale, setSelectedLocale] = useState<LocaleConstants>(null)
    const { getText } = use(DictionaryContext)

    const ChangeHandler = (option: SelectOption): void => {
        const locale = option.value as LocaleConstants
        setSelectedLocale(locale)
        setLocale(locale)
    }

    const options: SelectOption[] = [
        {
            label: getText('STO.COMMON.LOCALES.DUTCH'),
            value: LocaleConstants.NL,
        },
        {
            label: getText('STO.COMMON.LOCALES.ENGLISH'),
            value: LocaleConstants.EN,
        },
    ]

    return (
        <FormField
            name="language-switch"
            className="min-w-[10rem] relative bottom-[4px]"
            isQuiet
            screenReaderOnly
            label={<DictionaryText textKey="STO.COMMON.SELECT_LANGUAGE" />}
        >
            <SelectInput
                id="language-switch"
                options={options}
                value={selectedLocale}
                onChange={ChangeHandler}
                placeholder={getText('STO.COMMON.SELECT_LANGUAGE')}
            />
        </FormField>
    )
}

export default LanguageSwitch
